export const PAY_WITH_DATA_TEST_ID = 'pay-with-container'
export const CHAIN_SELECTOR_DATA_TEST_ID = 'chain-selector'
export const TOKEN_SELECTOR_DATA_TEST_ID = 'token-selector'
